import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { DollarSign, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const MyBookingFee = () => {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/api/services/my-provider`, {
      headers: { Authorization: `Bearer ${token}` },
      credentials: "include",
    })
      .then((r) => r.json())
      .then((d) => {
        const list = d.providers || [];
        setRows(list);
        setDrafts(Object.fromEntries(list.map((p) => [p.id, p.booking_fee ?? ""])));
      })
      .catch(() => {});
  }, [token]);

  const save = async (pid) => {
    const v = drafts[pid];
    setSaved((s) => ({ ...s, [pid]: "busy" }));
    try {
      const res = await fetch(`${API}/api/services/my-provider/${pid}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        credentials: "include",
        body: JSON.stringify({ booking_fee: v === "" ? null : Number(v) }),
      });
      setSaved((s) => ({ ...s, [pid]: res.ok ? "ok" : "error" }));
    } catch {
      setSaved((s) => ({ ...s, [pid]: "error" }));
    }
    setTimeout(() => setSaved((s) => ({ ...s, [pid]: undefined })), 2500);
  };

  if (rows.length === 0) return null;

  return (
    <div className="booking-fee-panel" data-testid="booking-fee-panel">
      <h3 className="req-title"><DollarSign size={15} /> My booking fee</h3>
      <p className="gd-upload-note">
        You're bookable — set the fee clients pay through Stripe when a booking with you is approved.
        Leave it blank for no fee (no payment link goes out).
      </p>
      {rows.map((p) => (
        <div className="booking-fee-row" key={p.id} data-testid={`booking-fee-row-${p.id}`}>
          <span className="booking-fee-type">{p.service_type}</span>
          <input
            className="req-input booking-fee-input"
            type="number"
            min="0.5"
            step="0.01"
            placeholder="Fee $"
            value={drafts[p.id] ?? ""}
            onChange={(e) => setDrafts((d) => ({ ...d, [p.id]: e.target.value }))}
            data-testid={`booking-fee-input-${p.id}`}
          />
          <button
            type="button"
            className="btn-mini approve"
            disabled={saved[p.id] === "busy"}
            onClick={() => save(p.id)}
            data-testid={`booking-fee-save-${p.id}`}
          >
            {saved[p.id] === "ok" ? <><Check size={13} /> Saved</> : saved[p.id] === "error" ? "Retry" : "Save"}
          </button>
        </div>
      ))}
    </div>
  );
};
